<template>
  <div class="modal-window large split active">
    <overlay-scrollbars :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
      <form @submit.prevent="handleSubmit">

        <div class="grid-x">
          <div class="cell large-12 flex-column">
            <div class="modal-window-header gray">
              <div class="modal-window-heading">
                <h3 class="icon-heading small">
                  <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-print"></use></svg></span>
                  <span class="icon-heading-title">
                    <span class="title">Utleveringsseddel</span>
                  </span>
                </h3>
              </div>
            </div>

            <div class="modal-window-body">
              <VueSignaturePad
                id="signature"
                width="100%"
                height="300px"
                ref="signaturePad"
                :options="signaturePadOptions"
              />
            </div>

            <div class="modal-window-footer">
              <div class="grid-x">
                <div class="cell">
                  <label for="Legtype">Legitimasjonstype <span v-show="form.Legitimert">*</span></label>
                  <div class="select-container">
                    <select id="Legtype" name="Legtype" v-model="form.Legtype">
                      <option v-for="option in legitimasjon" v-bind:value="option.key" v-bind:key="option.key">{{option.val}}</option>
                    </select>
                    <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-select"></use></svg></span>
                  </div>
                </div>
                <div class="cell align-right">
                  <a v-if="!$store.getters.isFormProcessing" href="javascript:;" @click="closeButtonClick()" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
                  <a v-else href="javascript:;" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
                  <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="saveSignature()" class="button primary submit large">Signer</a>
                </div>
              </div>
            </div>
          </div>
        </div>

      </form>
    </overlay-scrollbars>
  </div>
</template>

<script>
import Vue from 'vue'
import VueSignaturePad from 'vue-signature-pad'
import InstillingerService from '@/services/InstillingerService'
import SignatureService from '@/services/SignatureService'

Vue.use(VueSignaturePad)

export default {
  name: 'SignObjektModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    kundenr: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      legitimasjon: [],
      signaturePadOptions: {
        penColor: '#000'
      },
      form: {
        Legtype: 0
      }
    }
  },
  created () {
    this.loadForm()
  },
  methods: {
    loadForm: function () {
      this.legitimasjon = []

      InstillingerService('legitimasjon').dropdown()
        .then((response) => {
          this.legitimasjon = response.data
          this.legitimasjon.unshift({key: 0, val: 'Velg legitimasjonstype'})
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned innstillinger')
        })
        .then(() => {
          this.setFormLoading(false)
        })
    },
    saveSignature: function () {
      const {isEmpty, data} = this.$refs.signaturePad.saveSignature()

      if (!isEmpty) {
        SignatureService.save({
          'Objektnr': this.items.map(object => object.Objektnr),
          'LegitimasjonId': this.form.Legtype,
          'base64': data
        }).then((response) => {
          this.$store.dispatch('kundeobjektsignature/load', this.kundenr)
          this.$helpers.showSuccessAlert('Objekt signert')
          this.$emit('close')
        }).catch((error) => {
          // Put API errors into the error container
          this.$helpers.sendApiErrorsToValidator(error, this.errors)

          // Check if new errors appeared
          if (this.errors.any()) {
            this.errors.items.forEach((error) => {
              this.$helpers.showErrorAlert('Feil', error.field + ', ' + error.msg, false, 5000)
            })
            this.$validator.resume()
            this.$emit('close')
          }
        })
      }
    },
    closeButtonClick: function () {
      if (!this.$store.getters.isFormProcessing) {
        this.$emit('close')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/SignObjektModal.vue